// extracted by mini-css-extract-plugin
export default {"hiddenInput":"WbAcceptanceCertificate_hiddenInput__K3NOk"};